import { PricingRepository, PricingConfiguration, PricingTier } from '../types/PricingTypes';

export class B2BPricingDataRepository implements PricingRepository {
  public async getPricingConfiguration(): Promise<PricingConfiguration> {
    const tiers = [
      new PricingTier(
        'referral-partner',
        'Copper',
        'Professionals who want to refer clients to consulting but do not need to generate reports.',
        'Professionals who want to refer clients to consulting but do not need to pull credit.',
        ['Closed Client Referral Loop'],
        '/auth/subscriber-registration?tier=copper',
        'Subscribe Now',
        1
      ),
      new PricingTier(
        'bronze',
        'Bronze',
        'Individual Professionals or Smaller Businesses who want to refer clients to consulting and generate reports on case-by-case basis.',
        'Individual Professionals or Smaller Businesses',
        ['Closed Client Referral Loop', 'Access to ClientVitals Credit Report Packages'],
        '/auth/subscriber-registration?tier=bronze',
        'Subscribe Now',
        2
      ),
      new PricingTier(
        'silver',
        'Silver',
        'Team of Professionals or Businesses who want to refer clients to consulting and generate reports on a regular basis.',
        'Lenders and financial advisors',
        [
          'Closed Client Referral Loop', 'Access to ClientVitals Credit Report Packages', '5 Free Report Packages Per Month'
        ],
        '/auth/subscriber-registration?tier=silver',
        'Subscribe Now',
        3
      ),
      new PricingTier(
        'gold',
        'Gold',
        'Businesses who want to refer clients to consulting and generate reports in high-demand environments.',
        'Lenders and financial advisors who want the ability to pull their clients\' credit information.',
        [
          'Closed Client Referral Loop', 'Access to ClientVitals Credit Report Packages', '10 Free Report Packages Per Month'
        ],
        '/auth/subscriber-registration?tier=gold',
        'Subscribe Now',
        3
      ),
      new PricingTier(
        'trusted-partner',
        'Platinum',
        'Vetted ClientVitals Partners who wish to be a service option for consumers',
        'Vetted ClientVitals Partners who wish to be a service option for consumers',
        [
          'Closed Client Referral Loop', 'Access to ClientVitals Credit Report Packages', '10 Free Report Packages Per Month',
          'Promotion on Trusted Partner page'
        ],
        '/apply-partner',
        'Apply Now',
        5
      )
    ];


    const allFeatures = [
      'Client referrals for counseling',
      'Details, real-time credit reporting',
      'Multi-User Access (optional)', 
      'Action Maps',
      'Closed Client Loop',
      'Trusted Partner page'
    ];


    return new PricingConfiguration(tiers, allFeatures);
  }
}


export class B2CPricingDataRepository implements PricingRepository {
  public async getPricingConfiguration(): Promise<PricingConfiguration> {
    const tiers = [
      new PricingTier(
        'bronze',
        'Bronze',
        'Access to software that includes 1 free ClientVitals Credit Report Package.',
        'Clients',
        ['Discounted Intake & Assessment', '1 Report Package Per Month'],
        '/auth/client-registration?tier=bronze',
        'Subscribe Now',
        1
      ),
      new PricingTier(
        'silver',
        'Silver',
        'Full access to software and ClientVitals reports.',
        'Clients',
        ['Discounted Intake & Assessment', '1 Report Package Per Month', '1 ClientVitals Action Plan per Month'],
        '/auth/client-registration?tier=silver',
        'Subscribe Now',
        2
      ),
      new PricingTier(
        'gold',
        'Gold',
        'Full access to software, ClientVitals reports, and NEATT consulting experts.',
        'Clients',
        ['Discounted Intake & Assessment', '1 Report Package Per Month', '1 ClientVitals Action Plan per Month', 'Intake & Assessment Appointment', 'Follow-Up Appointment'],
        '/auth/client-registration?tier=gold',
        'Subscribe Now',
        3
      ),
    ];


    const allFeatures = [
      'Client referrals for counseling',
      'Details, real-time credit reporting',
      'Multi-User Access (optional)', 
      'Action Maps',
      'Closed Client Loop',
      'Trusted Partner page'
    ];


    return new PricingConfiguration(tiers, allFeatures);
  }
}